<template>
  <div class="d-flex flex-wrap">
    <div>
      <h5>
        Buyers who're not actively participating
        <CIcon
          v-c-tooltip="{
            content: 'Buyers who do not have a buyer campaign',
            placement: 'right',
          }"
          name="cil-info"
          size="custom"
          class="ml-1"
        />
      </h5>
      <div class="d-flex flex-column seller-offer-registration-list mr-5 mb-3">
        <div v-if="buyersNotParticipatingActively.length">
          <div
            v-for="buyer in buyersNotParticipatingActively"
            :key="buyer.id"
            class="seller-offer-registration-list__item pl-3"
          >
            <div class="d-flex py-1">
              <router-link
                target="_blank"
                title="View Account"
                class="text-truncate seller-offer-registration-list__item-account-name h5 mb-0"
                :to="{
                  name: 'BuyerAccountDetails',
                  params: { id: buyer.id },
                  exact: true,
                }"
              >
                {{ buyer.name }}
                <CIcon
                  name="cil-external-link"
                  size="custom"
                  class="ml-1"
                />
              </router-link>
              <a
                href
                title="Copy Account Id"
                class="ml-2"
                @click.prevent="
                  copyAccountIdToClipboard(buyer.id)
                "
              ><CIcon
                name="cil-copy"
              /></a>
            </div>
          </div>
        </div>
        <div
          v-else
        >
          <div class="seller-offer-registration-list__item">
            <i>All Buyers are actively participating</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import copyToClipboardMixin from '@/mixins/copy-to-clipboard-mixin'
import { showSuccessMessage } from '@/notification-utils'

export default {
  name: 'CategoryDemandInactive',

  mixins: [copyToClipboardMixin],

  props: {
    buyersNotParticipatingActively: {
      type: Array,
      default() {
        return []
      }
    },
  },

  data() {
    return {
    }
  },

  computed: {
  },

  methods: {
    copyAccountIdToClipboard(id) {
      this.copyTextToClipboard(id)
      showSuccessMessage('Account ID copied to clipboard')
    },
  }
}
</script>
<style lang="scss" scoped>
</style>